import type { IconProps } from '../types/IconProps.ts';
export const ListChevronsDownUp: IconProps = {
    name: 'ListChevronsDownUp',
    children: [
        `<path d="m14 19 3.25-2.9a.4.4 0 0 1 .5 0L21 19M3 5h7M3 12h7M3 19h7M14 5l3.25 2.9c.14.13.36.13.5 0L21 5" />`,
    ]
};